<template>
  <div class="capacity-container" :class="[zsTjTheme]">
    <div class="line">
      <div class="card w-336">
        <div class="header">
          <span class="label">绑定能力值：</span>
        </div>
        <div class="content">
          <div class="avatar">
            <div class="avatar-img">
              <img v-if="currentSkin && currentSkin.icon1" :src="currentSkin.icon1.value" alt="" />
            </div>
            <div class="btn" @click="handleChangeSkin">切换服装</div>
          </div>
          <div class="content-info">
            <template v-if="currentSkin && currentSkin.bindData">
              <div v-for="(item, index) in currentSkin.bindData" :key="item.name" class="info-line">
                <div class="label">{{ item.name }}</div>
                <div
                  class="value"
                  :style="{
                    paddingRight: String(item.value).includes('%') ? '20px' : '7px'
                  }"
                >
                  <el-input
                    :value="getResultValue(item.value)"
                    :controls="false"
                    @input="val => handleChangeValue(val, item.value, index, 'bindData')"
                  ></el-input>
                  <span v-if="item.value && String(item.value).includes('%')" class="percent">%</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="card normal w-389">
        <div class="box">
          <div class="header">
            <div class="left">
              <!-- <img src="@/assets/zs_imgs/zbtj/keyin-icon.png" alt="" class="icon" /> -->
              <SvgIcon class="icon" iconClass="zs-tj-keyin-icon" />
              <span class="label">刻印：</span>
            </div>
            <div class="right">
              <el-switch
                active-color="#5876A5"
                inactive-color="#0C0C0E"
                :value="isOpenKeyin"
                @change="handleChangeOptions('isOpenKeyin')"
              />
            </div>
          </div>
          <div class="content-info">
            <div v-for="key in Object.keys(initEngraving)" :key="key" class="info-line">
              <div class="label">{{ key }}</div>
              <div
                class="value"
                :style="{
                  paddingRight: String(initEngraving[key]).includes('%') ? '20px' : '7px'
                }"
              >
                <el-input
                  :value="getResultValue(engravingData[key], 0)"
                  :controls="false"
                  @input="val => handleChangeValue(val, initEngraving[key], key, 'engravingData')"
                ></el-input>
                <span v-if="initEngraving[key] && String(initEngraving[key]).includes('%')" class="percent">%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="header">
            <div class="left">
              <!-- <img src="@/assets/zs_imgs/zbtj/juexing-icon.png" alt="" class="icon" /> -->
              <SvgIcon class="icon" iconClass="zs-tj-juexing-icon" />
              <span class="label">觉醒：</span>
            </div>
            <div class="right">
              <el-switch
                active-color="#5876A5"
                inactive-color="#0C0C0E"
                :value="isOpenJuexing"
                @change="handleChangeOptions('isOpenJuexing')"
              />
            </div>
          </div>
          <div class="content-info">
            <div v-for="key in Object.keys(initAwakening)" :key="key" class="info-line">
              <div class="label">{{ key }}</div>
              <div
                class="value"
                :style="{
                  paddingRight: String(initAwakening[key]).includes('%') ? '20px' : '7px'
                }"
              >
                <el-input
                  :value="getResultValue(awakeningData[key], 0)"
                  :controls="false"
                  @input="val => handleChangeValue(val, initAwakening[key], key, 'awakeningData')"
                ></el-input>
                <span v-if="initAwakening[key] && String(initAwakening[key]).includes('%')" class="percent">%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card normal w-190">
        <div class="box">
          <div class="header">
            <div class="left">
              <img src="@/assets/zs_imgs/zbtj/zhencang-icon.png" alt="" class="icon" />
              <span class="label">珍藏集收益：</span>
            </div>
          </div>
          <div class="content-info">
            <div v-for="(item, index) in treasureData" :key="item.name" class="info-line">
              <div class="label">{{ item.name }}</div>
              <div
                class="value"
                :style="{
                  paddingRight: String(item.value).includes('%') ? '20px' : '7px'
                }"
              >
                <el-input
                  :value="getResultValue(item.value)"
                  :controls="false"
                  @input="val => handleChangeValue(val, item.value, index, 'treasureData')"
                ></el-input>
                <span v-if="item.value && String(item.value).includes('%')" class="percent">%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="public-line">
      <div class="tag">共用能力值：</div>
      <div v-for="key in skinList" :key="key" class="skin-item">
        <div class="avatar">
          <img
            v-if="styleData[key] && styleData[key].icon1 && styleData[key].icon1.value"
            :src="styleData[key].icon1.value"
            alt=""
            class="avatar-img"
          />
        </div>
        <template v-if="calcStyleData[key] && calcStyleData[key].skillData && calcStyleData[key].skillData.name">
          <div class="name">{{ calcStyleData[key].skillData.name }}</div>
          <div
            class="value"
            :style="{
              paddingRight: calcStyleData[key].skillData.value.includes('%') ? '20px' : '7px'
            }"
          >
            <el-input
              :value="
                publicData[key]
                  ? getResultValue(publicData[key].value)
                  : getResultValue(calcStyleData[key].skillData.value)
              "
              :controls="false"
              @input="val => handleChangeValue(val, calcStyleData[key].skillData.value, key, 'publicData')"
            ></el-input>
            <span
              v-if="calcStyleData[key].skillData.value && String(calcStyleData[key].skillData.value).includes('%')"
              class="percent"
              >%</span
            >
          </div>
        </template>
      </div>
    </div>
    <skin-modal ref="skinModalRef" :styleData="styleData" :current="currentSkin" @close="handleSaveSkin" />
  </div>
</template>
<script>
import SkinModal from "./skinModal.vue";
import { getResultValue } from "../index";
import { mapGetters } from "vuex";

export default {
  props: {
    styleData: {
      type: Object,
      default: () => ({})
    },
    currentSkin: {
      type: Object,
      default: () => ({})
    },
    // 珍藏集数据
    treasureData: {
      type: Array,
      default: () => []
    },
    // 共用能力
    publicData: {
      type: Object,
      default: () => ({})
    },
    // 刻印初始数据
    initEngraving: {
      type: Object,
      default: () => ({})
    },
    // 觉醒初始数据
    initAwakening: {
      type: Object,
      default: () => ({})
    },
    // 刻印数据
    engravingData: {
      type: Object,
      default: () => ({})
    },
    // 觉醒数据
    awakeningData: {
      type: Object,
      default: () => ({})
    },
    // 是否开启刻印
    isOpenKeyin: {
      type: Boolean,
      default: false
    },
    // 是否开启觉醒
    isOpenJuexing: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SkinModal
  },
  computed: {
    ...mapGetters(["zsTjTheme"]),
    skinList() {
      return Object.keys(this.styleData).filter(key => {
        return this.styleData[key].icon.hasValue;
      });
    },
    // 皮肤技能数据
    calcStyleData() {
      const result = {};
      for (let i = 0; i < this.skinList.length; i++) {
        const key = this.skinList[i];
        const item = this.styleData[key];
        result[key] = {
          skillData: {
            name: this.getPublicInfos(item.skill.ability1.desc.value, "name"),
            value: this.getPublicInfos(item.skill.ability1.desc.value, "value")
          }
        };
      }
      return result;
    }
  },
  data() {
    return {};
  },
  methods: {
    getResultValue,
    getPublicInfos(string, type) {
      if (!string) return "";
      const arr = string.split("：");
      if (type === "name") {
        return arr[0] ? arr[0].trim() : ""; // 返回名称部分
      }
      return arr[1] ? arr[1].trim() : ""; // 返回数值部分
    },
    handleChangeOptions(option) {
      if (option === "isOpenKeyin") {
        this.$emit("handleSwitch", "keyin"); // 切换刻印开关状态
      } else if (option === "isOpenJuexing") {
        this.$emit("handleSwitch", "juexing"); // 切换觉醒开关状态
      }
    },
    handleChangeSkin() {
      this.$refs.skinModalRef.visible = true; // 打开服装选择模态框
    },
    handleSaveSkin(data) {
      this.$emit("update", data); // 将选择的皮肤数据传递给父组件
    },
    handleChangeValue(value, bindValue, index, type) {
      // 先过滤掉value中的非数字字符
      value = String(value).replace(/[^0-9.-]/g, "");
      if (value === undefined || value === null) {
        console.warn("无效的值:", value);
        value = 0; // 如果值无效，设置为0
      }
      if (type === "bindData") {
        // this.$set(this.currentSkin.bindData[index], "value", value);
        this.$emit("update", {
          ...this.currentSkin,
          bindData: this.currentSkin.bindData.map((item, idx) => {
            if (idx === index) {
              return { ...item, value: String(bindValue).includes("%") ? `${value}%` : value };
            }
            return item;
          })
        });
      } else if (type === "treasureData") {
        // 处理珍藏集数据的更新
        const result = this.treasureData.map((item, idx) => {
          if (idx === index) {
            return { ...item, value: `${value}%` };
          }
          return item;
        });
        this.$emit("updateTreasure", result);
      } else if (type === "publicData") {
        // 处理共用能力数据的更新
        const result = {
          ...this.publicData,
          [index]: {
            value: String(bindValue).includes("%") ? `${value}%` : value
          }
        };
        this.$emit("updatePublicData", result);
      } else if (type === "engravingData") {
        const result = {
          ...this.engravingData,
          [index]: String(bindValue).includes("%") ? `${value}%` : value
        };
        this.$emit("updateEngravingData", result);
      } else if (type === "awakeningData") {
        const result = {
          ...this.awakeningData,
          [index]: String(bindValue).includes("%") ? `${value}%` : value
        };
        this.$emit("updateAwakeningData", result);
      } else {
        console.warn("未知类型:", type);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.capacity-container {
  flex: 0 0 auto;
  height: 347px;
  padding: 10px;
  background: rgba(38, 45, 54, 0.38);
  border-radius: 8px;
  .el-input {
    width: 100%;
    height: 100%;
    /deep/.el-input__inner {
      width: 100%;
      height: 100%;
      line-height: 28px;
      padding: 0 4px;
      color: #333;
      font-size: 14px;
      text-align: right;
      background: none;
      border: none;
      outline: none;
    }
  }
  .line {
    display: flex;
    margin-bottom: 8px;
    gap: 8px;
    .card {
      height: 179px;
      padding: 8px;
      background: rgba(11, 11, 12, 0.4);
      border-radius: 6px;
      box-sizing: border-box;
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 38px;
        padding: 0 4px;
        margin-bottom: 9px;
        background: rgba(59, 67, 89, 0.34);
        border-radius: 4px;
        .label {
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
        }
      }
      .content {
        display: flex;
        .avatar {
          flex: 0 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 38px;
          .avatar-img {
            position: relative;
            width: 72px;
            height: 72px;
            padding: 5px;
            margin-bottom: 11px;
            border: 1px solid #979797;
            border-radius: 50%;
            box-sizing: border-box;
            background-color: #000;
            overflow: hidden;
            img {
              position: absolute;
              left: -16px;
              top: -10px;
              width: 150%;
              height: 150%;
              border-radius: 50%;
            }
          }
          .btn {
            width: 89px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            font-weight: bold;
            font-size: 14px;
            color: #473228;
            cursor: pointer;
            background: #e1dad5;
            border-radius: 21px;
          }
        }
        .content-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 12px 0;
          .info-line {
            display: flex;
            align-items: center;
            .label {
              flex: 0 0 auto;
              margin-right: 12px;
              font-size: 14px;
              color: #ffffff;
            }
            .value {
              position: relative;
              flex: 1;
              height: 28px;
              background: rgba(10, 11, 12, 0.88);
              border-radius: 4px;
              font-size: 14px;
              color: #ffffff;
              .percent {
                position: absolute;
                right: 7px;
                top: 5px;
                color: #ffffff;
                font-size: 14px;
              }
            }
          }
        }
      }
      &.w-336 {
        width: 336px;
      }
      &.w-389 {
        display: flex;
        width: 389px;
      }
      &.normal {
        .box {
          width: 174px;
          padding-right: 12px;
          margin-right: 12px;
          border-right: 1px solid rgba(255, 255, 255, 0.1);
          box-sizing: content-box;
          .header {
            display: flex;
            align-items: center;
            width: 100%;
            height: 38px;
            padding: 0 4px;
            margin-bottom: 13px;
            .left {
              display: flex;
              align-items: center;
              .icon {
                width: 18px;
                height: 18px;
                margin-right: 8px;
              }
              .label {
                font-weight: 600;
                font-size: 16px;
                color: #ffffff;
              }
            }
          }
          .content-info {
            display: flex;
            flex-direction: column;
            gap: 12px 0;
            .info-line {
              display: flex;
              align-items: center;
              .label {
                flex: 0 0 auto;
                margin-right: 12px;
                font-size: 14px;
                color: #ffffff;
              }
              .value {
                position: relative;
                flex: 1;
                height: 28px;
                background: rgba(10, 11, 12, 0.88);
                border-radius: 4px;
                font-size: 14px;
                color: #ffffff;
                .percent {
                  position: absolute;
                  right: 7px;
                  top: 5px;
                  color: #ffffff;
                  font-size: 14px;
                }
              }
            }
          }
          &:last-child {
            padding-right: 0;
            margin-right: 0;
            border-right: none;
          }
        }
      }
    }
  }
  .public-line {
    display: flex;
    width: 100%;
    height: 139px;
    padding: 12px 0;
    box-sizing: border-box;
    background: rgba(11, 11, 12, 0.4);
    border-radius: 6px;

    .tag {
      width: 120px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      background: rgba(59, 67, 89, 0.34);
      border-radius: 0px 4px 4px 0px;
    }
    .skin-item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 136px;
      height: 100%;
      &::after {
        position: absolute;
        right: 0;
        top: 50%;
        content: "";
        width: 1px;
        height: 92px;
        background: rgba(255, 255, 255, 0.1);
        transform: translateY(-50%);
      }
      &:last-child::after {
        display: none;
      }
      .avatar {
        position: relative;
        width: 64px;
        height: 64px;
        padding: 4px;
        margin-bottom: 5px;
        box-sizing: border-box;
        border-radius: 50%;
        border: 1px solid #979797;
        background: #000000;
        overflow: hidden;
        .avatar-img {
          position: absolute;
          left: -16px;
          top: -10px;
          width: 150%;
          height: 150%;
          border-radius: 50%;
        }
      }
      .name {
        margin-bottom: 8px;
        font-size: 12px;
        color: #ffffff;
      }
      .value {
        position: relative;
        width: 64px;
        height: 28px;
        background: #0a0b0c;
        border-radius: 4px;
        .percent {
          position: absolute;
          right: 7px;
          top: 2px;
          color: #ffffff;
          font-size: 14px;
        }
      }
    }
  }
}

.capacity-container.light {
  background: rgba(226, 231, 230, 0.75);
  .el-input {
    /deep/.el-input__inner {
      color: #333;
    }
  }
  .line {
    .card {
      background: rgba(255, 255, 255, 0.73);
      .header {
        background: #e7f0f4;
        .label {
          font-weight: bold;
          color: #333333;
        }
      }
      .content {
        .avatar {
          .avatar-img {
            background-color: #e3e3e3;
            border: 1px solid #fff;
          }
        }
        .btn {
          background: rgba(136, 183, 201, 0.4);
          border: 1px solid #ffffff;
          font-weight: bold;
          color: #333333;
        }

        .content-info {
          .info-line {
            .label {
              font-weight: 500;
              color: #333333;
            }
            .value {
              border: 1px solid #d6dcdf;
              background: transparent;
              color: #333333;
              .percent {
                color: #333333;
              }
            }
          }
        }
      }

      &.normal {
        .box {
          border-right: 1px solid #d6dcdf;
          &:last-child {
            border-right: none;
          }
          .header {
            .left {
              .label {
                color: #333333;
              }
            }
          }

          .content-info {
            .info-line {
              .label {
                font-weight: 500;
                color: #333333;
              }

              .value {
                border: 1px solid #d6dcdf;
                background: transparent;
                color: #333333;
                .percent {
                  color: #333333;
                }
              }
            }
          }
        }
      }
    }
  }

  .public-line {
    background: rgba(255, 255, 255, 0.73);
    .tag {
      background: #e7f0f4;
      font-weight: bold;
      color: #333333;
    }

    .skin-item {
      position: relative;
      &::after {
        background: rgba(0, 0, 0, 0.15);
      }
      .avatar {
        background-color: #e3e3e3;
        border: 1px solid #fff;
      }
      .name {
        font-weight: 500;
        color: #333333;
      }
      .value {
        border: 1px solid #d6dcdf;
        background: transparent;
        color: #333333;
        .percent {
          color: #333333;
        }
      }
    }
  }
}
</style>
